import ServiceFailErreur from "./ServiceFailErreur";

class ServiceResponse {

  getResponse = (response) => {
    if (response.data.code === 0) {
      return ({"message": response.data.message, "error": "", "data": response.data})
    } else {
      return ({"message": "", "error": response.data.message, "data": null})
    }
  }
  getResponseNotMessage = (response) => {
    if (response.data.code === 0) {
      return ({"message": "", "error": "", "data": response.data})
    } else {
      return ({"message": "", "error": response.data.message, "data": null})
    }
  }

  getResponseError = (error) => {
     return({"message":"", "error": ServiceFailErreur.getErreur(error),
       "data":null, isInvalideToken:ServiceFailErreur.invalidTokenRequered(error)});
  }




    }

export default new ServiceResponse();
